import Header from "../components/header";
import PageTitle from "../components/page-title";
import PageNavigator from "../components/page-navigator";
import Holder from "../components/holder";
import { useState, useEffect, useRef } from "react";
import VoiceHolder from "../components/voice-holder";
import { openVoicePicker } from "../functions/openVoicePicker";
import NewVoiceModule from "../components/new-voice-module";
import { fetchVoices } from "../functions/fetchVoices";
import { updateVoiceApi } from "../functions/updateVoiceApi";
import { disconnectLinkedin } from "../functions/disconnectLinkedin";


function VoicesPage(){
    const [newVoiceOpen,setNewVoiceOpen] = useState(false);
    const [voices,SetVoices] = useState([]);
    const [initialLoadComplete,SetInitialLoadComplete] = useState(false);
    const [voiceToEdit, setVoiceToEdit] = useState(null);
    const isFirstRender = useRef(true);
    const isFromFetch = useRef(false);
        useEffect(() => {
        const waitForVoices = async () => {
            isFromFetch.current = true;
            await fetchVoices(SetVoices);
            SetInitialLoadComplete(true);
        };
        waitForVoices();
        }, []);

        useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (isFromFetch.current) {
            isFromFetch.current = false;
            return;
        }

        updateVoiceApi(voices);
        }, [voices]);

    const handleClick = () => {
            setVoiceToEdit(null); // reset if user is adding, not editing
            openVoicePicker(setNewVoiceOpen,newVoiceOpen);
    }
    const handleEditVoice = (voice) => {
    setVoiceToEdit(voice);
        openVoicePicker(setNewVoiceOpen,newVoiceOpen);
    };
    const updateVoice = (updatedVoice) => {
    SetVoices(prev =>
        prev.map(v => v.id === updatedVoice.id ? updatedVoice : v)
    );
    setVoiceToEdit(null);
    openVoicePicker(setNewVoiceOpen,newVoiceOpen);
    };
    const closeModule = () => {
        openVoicePicker(setNewVoiceOpen,newVoiceOpen);
    }
    const addVoice = (newVoice) => {
    SetVoices(prev => {
        if (prev.length >= 10) {
        alert("You can only have up to 10 voices.");
        return prev;
        }
        console.log(newVoice);
        if(newVoice.name === "All"){
            alert("Restricted voice name. Please select another");
            return prev
        }
        return [...prev, { ...newVoice, id: window.crypto.randomUUID() }];
    });
        openVoicePicker(setNewVoiceOpen,newVoiceOpen);
    };
    const deleteVoice = (idToDelete) => {
    SetVoices(prev => {
        if (prev[0].id === idToDelete) {
        console.warn("Cannot delete the default voice.");
        return prev;
        }
        return prev.filter(voice => voice.id !== idToDelete);
    });
    };

    const handleDisconnectLinkedin = async (voiceId) => {
        try {
            await disconnectLinkedin(voiceId);
        } catch (error) {
            // Backend may not be ready yet — still clear locally
        }
        SetVoices(prev =>
            prev.map(v =>
                v.id === voiceId
                    ? { ...v, linkedinEmail: null, linkedinStatus: null }
                    : v
            )
        );
    };

    return <>
    <Header CTA='Add new voice' functionForButton={handleClick}></Header>    

    <Holder 
    left={<PageNavigator numberSelected={4}/>}
    right={<>
        <PageTitle text='Manage your voices.' heading='Your voices.'></PageTitle>
    <VoiceHolder voices={voices} deleteVoice={deleteVoice} handleEditVoice={handleEditVoice}/>        </>}
    />
    <NewVoiceModule
    display={newVoiceOpen ? "flex" : "none"}
    functionForButton={closeModule}
    addVoice={addVoice}
    updateVoice={updateVoice}
    voiceToEdit={voiceToEdit}
    onDisconnectLinkedin={handleDisconnectLinkedin}
    />    </>
}
    
export default VoicesPage;